import Mooring from './Mooring';
export default class MooringSwinging extends Mooring {
    status;
    constructor(port, status, freeText) {
        super(port, freeText);
        this.status = status;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=MooringSwinging.js.map